import React from 'react';
import { Tooltip } from 'antd';
import { RetweetOutlined } from '@ant-design/icons';
import ImageFx from '../../../commonComponents/ImageFx';
import outboundIcon from '../../../assets/images/outbound_sku.svg';
import DamagedIcon from '../../../assets/images/damage_product.png';
import NotDamagedNotShootable from '../../../assets/images/notDamaged_notShootable.png';
import AuditPassedMark from '../../../commonComponents/AuditPassedMark';

function getRerunRequestStatus(sku) {
    if (!sku?.requestType) return null;
    return (
        <div
            style={{
                position: 'absolute',
                right: '2px',
                top: '28px',
                height: '25px',
                width: '25px',
                zIndex: 3,
                borderRadius: '50%',
                backgroundColor: sku?.isRawQCComplete ? 'rgba(249,245,245,0.5)' : 'rgba(255,0,0)',
                display: 'flex',
                justifyContent: 'center',
                alignItems: 'center',
                border: sku?.isRawQCComplete ? '1px solid red' : '1px solid white',
            }}
        >
            <Tooltip title={sku?.requestType}>
                <RetweetOutlined style={{ color: sku?.isRawQCComplete ? 'red' : 'white' }} />
            </Tooltip>
        </div>
    );
}

function getShootableDamagedTitle(sku) {
    if (sku?.isShootable && !sku?.isDamaged) return '';
    return `${sku?.isShootable ? 'Shootable' : 'Not Shootable'}  ${sku?.isDamaged ? 'and Damaged' : !sku?.isShootable ? '' : 'and Not Damaged'}`;
}

function getDamagedStatus(sku) {
    if (sku?.isShootable && !sku?.isDamaged) return null;
    return (
        <div
            style={{
                position: 'absolute',
                right: '2px',
                top: sku?.requestType ? '55px' : '28px',
                height: '25px',
                width: '25px',
                zIndex: 3,
                borderRadius: '50%',
                backgroundColor:
                    sku?.isDamaged && sku?.isShootable
                        ? 'rgb(6, 141, 169)'
                        : sku?.isDamaged && !sku?.isShootable
                            ? 'rgb(255, 146, 9)'
                            : 'rgba(249,245,245,0.5)',
                display: 'flex',
                justifyContent: 'center',
                alignItems: 'center',
                border:
                    sku?.isDamaged && sku?.isShootable
                        ? '1px solid white'
                        : sku?.isDamaged && !sku?.isShootable
                            ? '1px solid white'
                            : '1px solid rgb(61, 48, 162)',
            }}
        >
            <Tooltip title={getShootableDamagedTitle(sku)}>
                {!sku?.isDamaged && !sku?.isShootable ? (
                    <img src={NotDamagedNotShootable} alt="not shootable" style={{ position: 'relative', objectFit: 'contain', height: '20px' }} />
                ) : (
                    <img src={DamagedIcon} alt="damaged" style={{ position: 'relative', objectFit: 'contain', height: '20px' }} />
                )}
            </Tooltip>
        </div>
    );
}

function getOutboundStatus(sku) {
    if (!sku?.isOutbound) return null;
    return (
        <div
            style={{
                position: 'absolute',
                right: '2px',
                top:
                    sku?.requestType && !(sku?.isShootable && !sku?.isDamaged)
                        ? '85px'
                        : sku?.requestType || !(sku?.isShootable && !sku?.isDamaged)
                            ? '55px'
                            : '28px',
                height: '25px',
                width: '25px',
                zIndex: 3,
                borderRadius: '50%',
                backgroundColor: 'rgba(0,255,0,0.8)',
                display: 'flex',
                justifyContent: 'center',
                alignItems: 'center',
                border: '1px solid white',
            }}
        >
            <Tooltip title="Outbound Complete!">
                <img src={outboundIcon} alt="outbound" style={{ position: 'relative', objectFit: 'contain', height: '20px' }} />
            </Tooltip>
        </div>
    );
}

export default function HeroGarment({ sku, width = '180px', height = '240px' }) {
    return (
        <div style={{ width: 'max-content', height: 'max-content', position: 'relative' }}>
            <ImageFx
                image={sku?.article?.articleImage}
                header="Hero garment"
                caption={sku?.csvData?.EAN || sku?.csvData?.barcode || sku?.skuName}
                allowFullSize
                width={width}
                height={height}
                shootStatus={sku?.shootStatus}
                srNo={parseInt(sku?.skuName?.slice(sku?.skuName?.lastIndexOf('A') + 1))}
            />
            {getRerunRequestStatus(sku)}
            {getDamagedStatus(sku)}
            {getOutboundStatus(sku)}
            <AuditPassedMark sku={sku} />
        </div>
    );
}

export function ModelImage({ sku, width = '180px', height = '240px' }) {
    return (
        <ImageFx
            image={sku?.model?.image}
            header={sku?.model?.name || 'Model reference'}
            caption={sku?.model?.occassion}
            allowFullSize
            width={width}
            height={height}
        />
    );
}
